// Static content for the Trust & Safety page.
// Kept as plain data (instead of PageBuilder / hosted assets) so the page
// no longer depends on a fetched "trust-and-safety" page asset.
//
// All prose is referenced by translation message id (see en.json / th.json,
// keys prefixed "TrustAndSafetyPage.") so the content can be localized.

export const companyInfo = {
  name: 'Metta People Co., Ltd.',
  effectiveDate: 'July 2026',
};

// Block types used below:
// p        -> paragraph, { id }
// ul       -> bullet list, { items: [{ boldId, restId }] } — each item
//             renders as a bold lead-in phrase followed by the rest of the
//             sentence, e.g. "Identity verification — for every ..."
// callout  -> highlighted panel, { id?, email? } (email rendered as mailto
//             link; id is optional lead-in text before the email)

export const trustAndSafetySections = [
  {
    titleId: 'TrustAndSafetyPage.s1.title',
    accentBar: true,
    blocks: [
      {
        type: 'ul',
        items: [
          {
            boldId: 'TrustAndSafetyPage.s1.list1.bold',
            restId: 'TrustAndSafetyPage.s1.list1.rest',
          },
          {
            boldId: 'TrustAndSafetyPage.s1.list2.bold',
            restId: 'TrustAndSafetyPage.s1.list2.rest',
          },
          {
            boldId: 'TrustAndSafetyPage.s1.list3.bold',
            restId: 'TrustAndSafetyPage.s1.list3.rest',
          },
          {
            boldId: 'TrustAndSafetyPage.s1.list4.bold',
            restId: 'TrustAndSafetyPage.s1.list4.rest',
          },
        ],
      },
    ],
  },
  {
    titleId: 'TrustAndSafetyPage.s2.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'TrustAndSafetyPage.s2.body' }],
  },
  {
    titleId: 'TrustAndSafetyPage.s3.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'TrustAndSafetyPage.s3.body' }],
  },
  {
    titleId: 'TrustAndSafetyPage.s4.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'TrustAndSafetyPage.s4.body' }],
  },
  {
    titleId: 'TrustAndSafetyPage.s5.title',
    accentBar: true,
    blocks: [
      { type: 'p', id: 'TrustAndSafetyPage.s5.intro' },
      { type: 'callout', email: 'info@mettapeople.com' },
      { type: 'p', id: 'TrustAndSafetyPage.s5.outro' },
    ],
  },
  {
    titleId: 'TrustAndSafetyPage.s6.title',
    gradient: true,
    blocks: [{ type: 'p', id: 'TrustAndSafetyPage.s6.body' }],
  },
  {
    titleId: 'TrustAndSafetyPage.s7.title',
    accentBar: true,
    blocks: [{ type: 'p', id: 'TrustAndSafetyPage.s7.body' }],
  },
];
